// client/src/components/Services/Services.js (NEW)

import React from 'react';
import './Services.css';

// 1. Updated list with icons (emoji)
const serviceList = [
  { icon: '🎬', name: 'Film & Web Series Production' },
  { icon: '🎭', name: 'Acting & Talent Management' },
  { icon: '📣', name: 'Advertising & Brand Promotions' },
  { icon: '📱', name: 'Digital & Social Media Campaigns' },
  { icon: '🎵', name: 'Music Video & Short Film Creation' },
  { icon: '🎥', name: 'Event Coverage & Cinematography' },
];

const Services = () => {
  return (
    <section id="services" className="section services-section">
      <div className="services-content">
        <h2>💡 Our Services</h2>
        <ul className="services-list">
          {/* 2. New structure for the card content */}
          {serviceList.map((service, index) => (
            <li key={index} className="service-item">
              <div className="service-icon">{service.icon}</div>
              <h3 className="service-name">{service.name}</h3>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default Services;